import React, { Component } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

import getTimeFromDate from "../../assets/Js/getTimeFromDate";
import projectSettings from "../../assets/Js/projectSettings";
import DisplayPicture from "../../Components/DisplayPicture/DisplayPicture";

import alternateImage from "../../assets/Images/alternateImage.jpg";
import ReactLinkify from "react-linkify";

export default class Message extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      IsImageViewerOpen: false,
    };
  }

  openImageViewer = () => {
    this.setState({
      IsImageViewerOpen: true,
    });
  };

  closeImageViewer = () => {
    this.setState({
      IsImageViewerOpen: false,
    });
  };

  stopLoader = () => {
    this.props.scrollToBottom();
    this.setState({
      isLoading: false,
    });
  };

  render() {
    const {
      SenderId,
      Message,
      Date,
      ImageUrl,
      UserName,
      UserImage,
      IsWelcome,
      Unsent,
      Type,
    } = this.props.messageInfo;
    const isPersonalMessage = this.props.userId === SenderId;
    const MessageImage =
      Type === 1 ? projectSettings.baseImageUrl + "=" + ImageUrl : ImageUrl;
    const ImageToDisplay = this.state.isLoading ? alternateImage : MessageImage;

    return (
      <ReactLinkify
        componentDecorator={(decoratedHref, decoratedText, key) => (
          <a
            target="blank"
            href={decoratedHref}
            key={key}
            className={`messageLink ${
              isPersonalMessage ? "sendingLink" : "recievingLink"
            }`}
          >
            {decoratedText}
          </a>
        )}
      >
        {IsWelcome ? (
          <div className="w-100 mb-2 d-flex justify-content-center">
            <div className="badge rounded welcomeMessageChip">{Message}</div>
          </div>
        ) : (
          <li className={isPersonalMessage ? "replies" : "sent"}>
            <div className="wrap">
              <DisplayPicture
                image={UserImage}
                className="senderReceiverImage"
              />
            </div>
            <div>
              {!isPersonalMessage && (
                <>
                  <div className={`float-left senderNameStyle`}>{UserName}</div>
                  <br />
                </>
              )}
              <div className={`${isPersonalMessage && "float-right"}`}>
                <div className="d-flex align-items-center">
                  {Unsent && isPersonalMessage && (
                    <span className="text-danger mr-2">
                      <i className="mdi mdi-information h6"></i>
                    </span>
                  )}

                  <div
                    className={`chatMessageBox ${
                      isPersonalMessage
                        ? "primaryBgColor senderDesign"
                        : "lightBlueBgColor recieverDesign"
                    } ${ImageUrl && "chatMessagePadding"}`}
                  >
                    {ImageUrl ? (
                      <>
                        <img
                          onLoad={this.stopLoader}
                          onClick={this.openImageViewer}
                          src={ImageToDisplay}
                          alt="not found"
                          className={`gifStyle m-0 ${
                            isPersonalMessage
                              ? "senderDesign"
                              : "recieverDesign"
                          }`}
                        />
                        <div>
                          {this.state.IsImageViewerOpen && (
                            <Lightbox
                              image={ImageToDisplay}
                              title="Image Title"
                              onClose={this.closeImageViewer}
                            />
                          )}
                        </div>
                      </>
                    ) : (
                      <p className={`message-box float-left`}>{Message}</p>
                    )}

                    <p className={`messageDataSent`}>{getTimeFromDate(Date)}</p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        )}
      </ReactLinkify>
    );
  }
}
